import { render, staticRenderFns } from "./FileField.form-builder.vue?vue&type=template&id=8c6f72c0&"
import script from "./FileField.form-builder.vue?vue&type=script&lang=js&"
export * from "./FileField.form-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports